(() => {
  if (customElements.get('bc-team-stack')) return;
  customElements.define('bc-team-stack', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const tooltip = this.querySelector('.bc-team-stack__tooltip');
      const caption = this.closest('.bc-contact__intro')?.querySelector('[data-team-caption]');
      const hideTooltip = () => { tooltip.hidden = true; };
      const positionTooltip = selected => {
        const portrait = selected.getBoundingClientRect();
        const width = tooltip.getBoundingClientRect().width;
        const left = Math.max(16, Math.min(innerWidth - width - 16, portrait.left + portrait.width / 2 - width / 2));
        this.style.setProperty('--team-tip-left', `${left - this.getBoundingClientRect().left}px`);
      };
      const activate = event => {
        const selected = event.target.closest('.bc-team-stack__person');
        if (!selected || !this.contains(selected)) return;
        this.querySelectorAll('.bc-team-stack__person').forEach(person => {
          const active = person === selected;
          person.classList.toggle('is-front', active);
          person.setAttribute('aria-pressed', String(active));
        });
        const name = selected.dataset.teamName;
        const role = selected.dataset.teamRole;
        tooltip.querySelector('[data-team-tooltip-name]').textContent = name;
        tooltip.querySelector('[data-team-tooltip-role]').textContent = role;
        if (caption) {
          caption.querySelector('[data-team-caption-name]').textContent = name;
          caption.querySelector('[data-team-caption-role]').textContent = role;
        }
        tooltip.hidden = Boolean(caption);
        if (!caption) positionTooltip(selected);
      };
      this.addEventListener('pointerover', event => { if (event.pointerType !== 'touch') activate(event); }, { signal });
      this.addEventListener('focusin', activate, { signal });
      this.addEventListener('click', activate, { signal });
      this.addEventListener('pointerleave', event => { if (event.pointerType !== 'touch') hideTooltip(); }, { signal });
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) hideTooltip(); }, { signal });
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) hideTooltip(); }, { signal });
      this.addEventListener('keydown', event => { if (event.key === 'Escape') hideTooltip(); }, { signal });
      window.addEventListener('resize', () => {
        if (!tooltip.hidden) positionTooltip(this.querySelector('.is-front'));
      }, { signal, passive: true });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
})();
